<div class="mobile-datatable" infiniteScroll [infiniteScrollDistance]="1" #scrollContainer
[infiniteScrollThrottle]="500"
(scrolled)="onPageChange(offerState.page + 1)" (scrolledUp)="onScrollUp()"
[scrollWindow]="true">
  <header id="history">
    <span class="label-sample" title="Produit"></span>
    <span *ngIf="actionTemplate" class="label-rest" title="Produit"></span>
  </header>
  
  <app-history-mobile-list-item *ngFor="let obj of paginatedObjects" [obj]="obj" [properties]="properties"
    [titleProperty]="titleProperty" [actionTemplate]="actionTemplate" [titleTemplate]="titleTemplate"
    [subtitleTemplate]="subtitleTemplate"></app-history-mobile-list-item>

<!--   <app-pagination appScrollOnPageChange anchor="history" [count]="objects.length" [currentPage]="page" [limit]="limit" (pageEmitter)="page = $event"></app-pagination>
 -->
</div>
